import { Column, Row, Typography } from '@/components'
import { Breakpoint } from '@/enums'
import { themeBreakpointDown } from '@/utils'
import styled from 'styled-components'
import { prop } from 'styled-tools'

export const MissingCoverageContainer = styled(Column)`
  width: 100%;
  border: 1px solid ${(props) => props.theme.color.b30};
  border-radius: 16px;
  align-items: center;
  gap: 24px;
  padding: 24px;
  position: relative;
  background-color: ${(props) => props.theme.color.b0};
  top: 0;

  > button {
    position: absolute;
    bottom: 8px;
    right: 16px;
    svg {
      height: 10px;
      width: 10px;

      > path {
        stroke: ${(props) => props.theme.color.info1};
      }
    }
  }
`

export const MissingCoverageChartContainer = styled(Column)`
  height: 180px;
  width: 180px;
  max-height: 100%;
  border-radius: 8px;
  position: relative;
  justify-content: center;
  min-width: 0;

  > div {
    height: 100% !important;
  }
`

export const CustomTooltipComponent = styled(Row)`
  background-color: white;
  padding: 8px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  align-items: center;
  gap: 4px;

  > span {
    white-space: nowrap;
  }
`

export const MissingCoverageLegendContainer = styled(Column)`
  width: 100%;
  justify-content: center;
  gap: 16px;
  max-width: 280px;

  ${themeBreakpointDown(Breakpoint.md)} {
    max-width: 100%;
  }
`

export const MissingCoverageLegendItem = styled(Row)`
  justify-content: space-between;
  gap: 8px;
`

export const MissingCoverageLegendColor = styled.div`
  background-color: ${prop('color')};
  height: 12px;
  width: 12px;
  border-radius: 50%;
  margin-right: 4px;
  flex-shrink: 0;
`

export const MissingCoverageLegendItemTitleRow = styled(Row)`
  align-items: center;
  overflow: hidden;
`

export const MissingCoverageLegendItemButton = styled(Row)<{
  onClick?: () => void
}>`
  align-items: center;
  gap: 4px;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  overflow: hidden;
`

export const PriceText = styled(Typography)`
  white-space: nowrap;
`

export const MiddleTextWrapper = styled(Column)`
  position: absolute;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  width: 100%;
  gap: 8px;
  pointer-events: none;

  > span:first-child {
    font-size: 10px;
    color: ${(props) => props.theme.color.b50};
  }

  > span:last-child {
    font-weight: 700;
    font-size: 10px;
    color: ${(props) => props.theme.color.b50};
  }
`

export const LegendTitle = styled(Typography)`
  font-weight: 400;
`
